import { Box, Progress, Text } from "@chakra-ui/react";
import { Pipeline } from "..";
import { PIPELINE_STAGES_WITH_CONTENT } from "../higienizacao-progress";
import { groupStepData } from "../utils";
import { Fragment } from "react";

export function PipelineProgress({
  modalData,
  pipelineStage,
  currentKeyBanco,
}: {
  modalData: Pipeline[] | undefined;
  pipelineStage: Pipeline["pipelineStage"];
  currentKeyBanco: string;
}) {
  let pipelinesWithContent = modalData?.filter((higienizacao) =>
    PIPELINE_STAGES_WITH_CONTENT.includes(higienizacao.pipelineStage)
  );

  if (pipelinesWithContent && pipelinesWithContent.length > 0) {
    const groupedData = groupStepData(pipelinesWithContent, pipelineStage);

    return (
      <Box py="12px">
        {Object.keys(groupedData).map((stageKey, i) => {
          const group = groupedData[stageKey];
          return (
            <Fragment key={stageKey}>
              {Object.keys(group).map((keyBanco, i) => {
                const currentGroup = group[keyBanco];
                const currentGroupData = currentGroup.data! as any[];
                const successHigienizacaoProgress =
                  currentGroupData?.filter(
                    ({ lastError, mensagem, status }) =>
                      !lastError && !mensagem && status === "EM_ANDAMENTO"
                  ) || [];

                if (keyBanco !== currentKeyBanco) return null;

                return (
                  <Fragment key={keyBanco}>
                    {successHigienizacaoProgress?.map(
                      ({ totalCompleted = 0, total = 0 }, i) => {
                        return (
                          <Fragment key={`bank-data-${i}`}>
                            <Text mb="5px" fontWeight="semibold">
                              Progresso {totalCompleted} de {total}
                            </Text>
                            <Box>
                              <Progress
                                colorScheme="progressColor"
                                value={(totalCompleted / total) * 100}
                                hasStripe
                                borderRadius="full"
                                size="sm"
                              />
                            </Box>
                          </Fragment>
                        );
                      }
                    )}
                  </Fragment>
                );
              })}
            </Fragment>
          );
        })}
      </Box>
    );
  } else {
    return null;
  }
}
